import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { OrderProduct } from '../../entities/order-product/OrderProduct'
import Modal from '../modal/Modal'
import ProductControlSwitcher from '../product-control-switcher/ProductControlSwitcher'
import ProductItem from '../product-item/ProductItem'
import ProductDeclineButton from '../product-decline-button/ProductDeclineButton'
import messages from './ProductInProgressModal.messages'

export interface IOwnProps {
  product: OrderProduct
  open: boolean
  onClose: () => void
}

export interface IStateProps { }

export interface IDispatchProps {
  requestPrint:         (product: OrderProduct) => void
  requestReprint:       (product: OrderProduct) => void
  requestRemoveLabels:  (products: OrderProduct[]) => void
}

const ButtonsContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
  width: '100%',
})

const HintContainer = styled('div')(({ theme }) => ({
  textAlign: 'center',
  marginBottom: 12,
  color: theme.palette.blackColor.light,
}))

export type IProps = IOwnProps & IStateProps & IDispatchProps

const ProductInProgressModal: React.FC<IProps> = (props) => {
  const {
    product,
    open,
    onClose,
    requestPrint,
    requestReprint,
    requestRemoveLabels,
  } = props

  const handleUnpackClick = () => {
    requestRemoveLabels([product])
    onClose()
  }

  const handleRePrintClick = () => {
    requestReprint(product)
    onClose()
  }

  const handlePrintClick = () => {
    requestPrint(product)
    onClose()
  }

  return (
    <Modal
      modalName='product-unpack'
      open={open}
      onClose={onClose}
      header={() => (
        <ProductItem
          product={product}
          shouldShowControls={false}
          shouldOpenModal={false}
          isModal={true}
        />
      )}
    >
      {product.isCanceled &&
        <HintContainer>
          <FormattedMessage {...messages.unpackToDetach} />
        </HintContainer>
      }
      {product.label
        ? (
          <ProductControlSwitcher
            initialContent={() => (
              <Button
                onClick={handleUnpackClick}
                variant='contained'
                color='primary'
                fullWidth
              >
                <FormattedMessage {...messages.unpack} />
              </Button>
            )}
            toggleContent={() => (
              <ButtonsContainer>
                <Button
                  onClick={handleRePrintClick}
                  variant='contained'
                  color='secondary'
                  fullWidth
                >
                  <FormattedMessage {...messages.rePrintLabel} />
                </Button>

                <ProductDeclineButton product={product} onModalClose={onClose} />
              </ButtonsContainer>
            )}
          />
        )
        : (
          <ButtonsContainer>
            <Button
              onClick={handlePrintClick}
              disabled={!product.order?.hasFinalPo()}
              variant='contained'
              color='primary'
              fullWidth
            >
              <FormattedMessage {...messages.printLabel} />
            </Button>

            <ProductDeclineButton product={product} onModalClose={onClose} />
          </ButtonsContainer>
        )}
    </Modal>
  )
}

export default ProductInProgressModal
